import React from 'react';

import { UiButton } from './ui-button';

import { ICON_NAMES, MaterialDesignIcon } from '../util/material-design-icons';

export const UiHideShowToggle = ({
  isOpen,
  title,
  onChange,
  className,
}: {
  isOpen: boolean;
  title: string;
  onChange: () => void;
  className?: string;
}) => (
  <UiButton onClick={onChange} variant="dismiss" size="sm" className={className || ''}>
    {isOpen ? (
      <MaterialDesignIcon iconName={ICON_NAMES.EXPAND_LESS} size="sm" />
    ) : (
      <MaterialDesignIcon iconName={ICON_NAMES.EXPAND_MORE} size="sm" />
    )}
    <span className="typo-label-v2">
      {isOpen ? 'Hide' : 'Show'} {title}
    </span>
  </UiButton>
);
